/** The withdrawal email link, and 404. */
import { Button, Notice, buttonClasses, formatAmount } from "@custos/ui";
import { useMutation } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { Link } from "react-router";
import { PageHeader } from "../components/AppShell";
import { AuthLayout } from "../components/AuthLayout";
import { withdrawalStatus } from "../lib/activity";
import { api } from "../lib/api";
import { errorMessage } from "../lib/errors";

/** Opened from the withdrawal confirmation email. Confirms only on an explicit click (email scanners open links). */
export function ConfirmWithdrawalPage() {
  const [token] = useState(() => new URLSearchParams(window.location.hash.slice(1)).get("token"));
  useEffect(() => {
    if (window.location.hash) history.replaceState(null, "", window.location.pathname);
  }, []);
  const confirm = useMutation({ mutationFn: () => api.confirmWithdrawalEmail(token!) });

  return (
    <AuthLayout title="Confirm withdrawal" subtitle="Only confirm a withdrawal you asked for yourself.">
      <div className="flex flex-col gap-4">
        {!token && <Notice tone="danger">This link is incomplete. Open the full link from the email.</Notice>}
        {confirm.data ? (
          <Notice tone="success" title="Withdrawal confirmed">
            {formatAmount(confirm.data.amount, 8)} {confirm.data.asset} —{" "}
            {withdrawalStatus(confirm.data).help}
          </Notice>
        ) : (
          token && (
            <>
              <Notice tone="warning">
                If you didn't ask for this withdrawal, don't confirm it. Log in, cancel it and change your
                password.
              </Notice>
              {confirm.error && <Notice tone="danger">{errorMessage(confirm.error)}</Notice>}
              <Button block loading={confirm.isPending} onClick={() => confirm.mutate()}>
                Yes, confirm my withdrawal
              </Button>
            </>
          )
        )}
        <Link to="/activity" className={buttonClasses("secondary", "md", true)}>
          Go to activity
        </Link>
      </div>
    </AuthLayout>
  );
}

export function NotFoundPage() {
  return (
    <>
      <PageHeader title="Page not found" />
      <Link to="/" className={buttonClasses("secondary")}>
        Back to Home
      </Link>
    </>
  );
}
